










































import omit from 'lodash/omit';
import { State } from 'vuex-class';
import { Mixins, Component } from 'vue-property-decorator';
import UserDto, { UserProfileDto } from '@/app/user/dto/user.dto';
import { required } from '@/app/core/validation';
import FormMixin from '@/app/core/mixins/form.mixin';

@Component
export default class EditProfileForm extends Mixins(FormMixin) {
  @State(state => state.user)
  private user!: UserDto;

  protected data: UserProfileDto = {
    firstname: '',
    lastname: '',
  };

  protected rules = {
    firstname: [required],
    lastname: [required],
  };

  created() {
    this.data = omit(this.user.profile, 'picture');
  }
}
